module.exports = require("dgram");


//////////////////
// WEBPACK FOOTER
// external "dgram"
// module id = 154
// module chunks = 0